import { LayoutPersonal } from '../../../layouts/personal/index';
/*
 * @Author: your name
 * @Date: 2022-03-08 15:09:45
 * @LastEditTime: 2022-03-10 15:08:03
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \pscd-portal-middle-office\packages\www\src\pages\personal\bindmobile\locales.ts
 */
export const EnumPageMeta: IEnumPageMeta = {
    /** 页面名称 */
    title: "绑定手机",
    login: true,
    layout: 'personal'
}
/**
 * 字段描述 枚举
 */
export enum EnumLocaleLabel {
    /** 姓名 */
    mobile = "bindmobile.mobile",
    imgCode = "bindmobile.imgCode",
    verificationCode= "bindmobile.verificationCode",
    oldpwd="bindmobile.oldpwd",
    newpwd="bindmobile.newpwd",
    confirmpwd="bindmobile.confirmpwd"
}
export enum EnumGender {

}
export default {
    en: {
        [EnumLocaleLabel.mobile]: 'mobile',
        [EnumLocaleLabel.imgCode]: 'imgCode',
        [EnumLocaleLabel.verificationCode]: 'verificationCode',
        [EnumLocaleLabel.oldpwd]: 'oldpwd',
        [EnumLocaleLabel.newpwd]: 'newpwd',
        [EnumLocaleLabel.confirmpwd]: 'confirmpwd',
    },
    zh: {
        [EnumLocaleLabel.mobile]: '手机号',
        [EnumLocaleLabel.imgCode]: '图形验证码',
        [EnumLocaleLabel.verificationCode]: '短信验证码',
        [EnumLocaleLabel.oldpwd]: '旧密码',
        [EnumLocaleLabel.newpwd]: '新密码',
        [EnumLocaleLabel.confirmpwd]: '确认密码',
    }
}